var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import { plural } from '@lingui/core/macro';
import { Box, TableBodyCell, TableCellEmpty, TableCellText, Typography } from '@pocketlaw/tetris';
function PartiesCellComponent(props) {
    const { data } = props, rest = __rest(props, ["data"]);
    const parties = Array.isArray(data) ? data : [];
    const [first, second] = parties;
    const itemsCount = parties.length;
    if (!itemsCount) {
        return (<TableBodyCell {...rest}>
        <TableCellEmpty />
      </TableBodyCell>);
    }
    const additionalText = plural(itemsCount, {
        one: '1 party',
        other: '# parties',
    });
    if (itemsCount > 2) {
        return (<TableBodyCell maxWidth={200} {...rest}>
        <TableCellText primary={parties.join(', ')} secondary={additionalText}/>
      </TableBodyCell>);
    }
    return (<TableBodyCell maxWidth={200} {...rest}>
      <Box flexDirection="column">
        <Typography $truncate $appearance="300" $fontSize="small" $lineHeight="neutralized">
          {first}
        </Typography>
        {second && (<Typography $truncate $appearance="300" $fontSize="small" $lineHeight="neutralized">
            {second}
          </Typography>)}
      </Box>
    </TableBodyCell>);
}
export const PartiesCell = memo(PartiesCellComponent);
